import React, { ComponentProps, useState } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { classnames } from 'Utils/classnames/classnames.utils';
import ratios from 'Components/utils/ratios/ratios.utils';
import Image from 'Components/frameworks/image/Image';
export type ProductMustTryCardProps = {
  className?: string;
  description: string;
  id?: string;
  imageSrc: string;
  onClick?: (isExpanded?: boolean) => void;
  seeMoreLabel?: string;
  title: string;
};
export const ProductMustTryCard = ({
  className,
  description,
  id,
  imageSrc,
  onClick,
  seeMoreLabel,
  title,
}: ProductMustTryCardProps) => {
  const [isExpanded, setExpanded] = useState(false);
  return (
    <button
      className={classnames('text-initial h-full w-full overflow-hidden', className)}
      data-testid="ProductMustTryCard"
      id={id}
      onClick={() => {
        onClick?.(isExpanded);
        setExpanded(!isExpanded);
      }}
      type="button"
    >
      <span className="relative isolate block h-full pb-50">
        <span className="block overflow-hidden rounded-12 bg-lightGrey">
          <Image
            {...asWidgetProps<ComponentProps<typeof Image>>({
              altMsg: '',
              groupKey: 'thumbnails',
              imageUrl: imageSrc,
              ratioKey: ratios.R_38_BY_28,
              ratioDisplay: 1 / 4,
            })}
          />
        </span>
        <span className="block max-h-55 overflow-hidden px-15 pt-15 text-center text-16 font-bold leading-tight">
          {title}
        </span>
        {!!seeMoreLabel && (
          <span className="absolute inset-x-0 bottom-0 my-15 block text-center text-14 underline">
            {seeMoreLabel}
          </span>
        )}
        <span
          className={classnames(
            'transition-transform absolute top-full mx-5 mt-5 block max-h-full transform overflow-y-auto rounded-12 bg-white px-20 pb-5 pt-20 text-center duration-250 ease-in',
            {
              '-translate-y-full': isExpanded,
              'translate-y-0': !isExpanded,
            },
          )}
        >
          <span className="mb-20 block text-18 font-bold">{title}</span>
          <span className="block text-14">{description}</span>
        </span>
      </span>
    </button>
  );
};
